import React from 'react';
import { choose } from '../../utils/platform';
import { useForgotPassword } from './useForgotPassword';
import ForgotPasswordDesktop from './ForgotPassword.desktop';
import ForgotPasswordMobile from './ForgotPassword.mobile';

const ForgotPasswordView = choose(ForgotPasswordDesktop, ForgotPasswordMobile);

export default function ForgotPassword() {
  const vm = useForgotPassword();
  return <ForgotPasswordView vm={vm} />;
}
